<template>
  <aw-dropdown
    v-if="enable" 
    placement="bottom"
    :offset="[0, 2]"
    :hover="true"
  >
    <template v-slot:btn="{ open }">
      <button 
        @click="startTour()"
        @mouseover="open()"
        :disabled="!tourAvailable"
        :class="{'text-white': tourAvailable}"
      >
        <aw-icon 
          icon="superquestion" 
          class="w-5 h-5"
        />
      </button>
    </template>
    <template v-slot:dropdown="{ opened, dropdown, close }">
      <div
        class="Dropdown Dropdown--Short Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
        v-show="opened"
        :ref="dropdown"
      >
        <nav class="p-0">
          <a 
            :href="resetLink" 
            rel="noopener noreferrer"
            class="flex items-center py-1.5 px-3 text-gray-600 hover:text-gray-800 ajax"
            data-ajax-off="vue-render,vue-router"
            @click="resetViewed(close)"
          >
            {{ $t('Reset tooltips') }}
          </a>
          <a 
            :href="documentationLink" 
            target="_blank" 
            rel="noopener noreferrer"
            class="flex items-center py-1.5 px-3 text-gray-600 hover:text-gray-800"
            @click="close"
          >
            {{ $t('How to?') }}
          </a>
        </nav>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
import { watch, watchEffect, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useWindowSize } from '@vueuse/core'
import { showDriver, availableScenarios, autoplayScenarios, scenarios, currentRole, viewedAutoplayScenariosIds } from './AwDriverContext'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import useBcDocumentStore from '@/frontapp/store/bcDocument'

export default {
  props: {
    scenarios: {
      type: Array,
      default: () => [],
    },
    resetLink: {
      type: String,
      default: null,
    },
    adminRole: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const tourAvailable = computed(() => {
      return availableScenarios.value.length > 0
    })
    const route = useRoute()
    const { width } = useWindowSize()
    const bcFolderStore = useBcFolderStore()
    const bcDocumentStore = useBcDocumentStore()
    
    const enable = computed(() => {
      return width.value >= 768
    })
    
    const routesDocument = [
      'BCDocument', 
      'BCDocumentDetail', 
      'BCDocumentDetailRev',
    ]

    const routesFolder = [
      'BCFolder', 
      'BCHome',
    ]

    const startTour = () => {
      showDriver.value = true
    }

    const resetViewed = (close) => {
      viewedAutoplayScenariosIds.clear()
      const newScenarios = JSON.parse(JSON.stringify(props.scenarios))
      newScenarios.forEach((scenario) => {
        scenario.viewed = false
      })
      scenarios.value = newScenarios
      close()
    }

    watchEffect(() => {
      if (props.adminRole) {
        currentRole.value = 'Admin'
        return
      }

      currentRole.value = (routesFolder.includes(route.matched[0].name) && bcFolderStore.current?.can_edit)
        || (routesDocument.includes(route.matched[0].name) && bcDocumentStore.document?.can_edit)
        ? 'Edit'
        : 'View'
    })

    watch(
      [
        () => props.scenarios, 
        () => route,
        () => bcFolderStore.loading, 
        () => bcFolderStore.current,
        () => bcDocumentStore.loading, 
        () => bcDocumentStore.document,
      ],
      ([newScenarios, newRoute]) => {
        if (
          routesFolder.includes(newRoute.matched[0].name) && (!bcFolderStore.current || bcFolderStore.loading) ||
          routesDocument.includes(newRoute.matched[0].name) && (!bcDocumentStore.document || Object.keys(bcDocumentStore.document).length === 0 || bcDocumentStore.loading)
        ) {
          return
        }

        scenarios.value = newScenarios
      },
      { immediate: true }
    )

    watch(autoplayScenarios, (newAutoplayScenarios) => {
      if (newAutoplayScenarios && newAutoplayScenarios.length > 0) {
        showDriver.value = 'auto'
      }
    })

    return {
      startTour,
      tourAvailable,
      enable,
      resetViewed,
    }
  },
  computed: {
    documentationLink() {
      if (this.$presenter.language.lang === 'cs' || this.$presenter.language.lang === 'sk') {
        return 'https://www.brandcloud.pro/cs/dokumentace'
      }

      return 'https://www.brandcloud.pro/en/docs'
    }
  }
}
</script>
